<div class="pending-container">
  <app-search-guides #searchGuides
                     class="block mt-48px"
                     [associatedInsiderId]="associatedInsiderId"
                     [gridType]="types.GuidesGridType.AcceptReject"
                     [status]="types.GuideStatus.Pending"></app-search-guides>
</div>
